



















import { CartItem } from '@/models/cart/cart-item'
import { AppliedBundleDiscount, BundleDiscount } from '@/services/api/bundle-discount'
import BundleDiscountGroupList from '@spa/components/pages/cart/components/cart/group/BundleDiscountGroupList.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    BundleDiscountGroupList,
  },
})
export default class BundleDiscountSection extends Vue {
  @Prop({ required: true })
  readonly cartItems: CartItem[]

  @Prop({ required: true })
  readonly appliedBundleDiscounts: AppliedBundleDiscount[]

  @Prop({ required: true })
  readonly bundleDiscounts: BundleDiscount[]

  isAccordionOpen = false

  get state(): string {
    return this.isAccordionOpen ? 'fa-chevron-up' : 'fa-chevron-down'
  }

  onToggleBundleDiscountAccordion() {
    this.isAccordionOpen = !this.isAccordionOpen
  }
}
